export const tableColumns = [
    {
        title: "backoffice.promo.brands",
        dataIndex: "name",
    },
    {
        title: "backoffice.promo.url",
        dataIndex: "url",
    },
]